<template>
  <div>
      <v-row>
          <v-spacer></v-spacer>
          <form @submit="onSubmit" method="post">
          <v-col cols="12" xs="7" sm="7" md="7" lg="7" xl="7">
              <v-card flat outlined class="mt-14">
                  <v-card-title class="text-h3 font-weight-light">Create Incident</v-card-title>
                    <h3 class="font-weight-regular ml-5">Create an incident record to report and request assistance with an issue you are having</h3>
                  <v-divider></v-divider>
                <h2 class="ma-7 font-weight-regular">*Urgency</h2>
                <v-select
                type="select"
                class="ma-7"
                outlined
          :items="items"
          item-text="status"
          v-model="incident.priority" 
        ></v-select>



                <h2 class="ml-7 font-weight-regular">*Please describe your issue below</h2>
                <v-text-field
                class="ma-7 mt-2"
                          type="text"
                          placeholder="Description"
                          outlined
                          v-model="incident.description"
                        ></v-text-field>
                <p class="text-center"><v-btn dark width="20vw"  type="submit">Submit</v-btn></p>
              </v-card>
          </v-col>
          </form>
          <v-spacer></v-spacer>
      </v-row>
  </div>
</template>

<script>
import axios from "axios";
  export default {
    data () {
      return {
        items: [
          { status: '--None--'},
          { status: '1'},
          { status: '2'},
          { status: '3'},
        ],
        incidents:[],
          incident:{
              priority: "",
              description: "",
          }
      }
    },
    methods: {
    onSubmit(e) {
        console.log()
      axios.post("https://operationwise.herokuapp.com/incidents", this.incident)
        .then((res) => {
          console.log(res.data);
        });
      e.preventDefault()
    },
  },
  }
</script>

<style>

</style>